import React from 'react';
import { FieldPassword } from './FieldPassword';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { checkPassword } from 'client/tools/checkPassword';
import { renderFaIcons, stringToBoolean } from 'client/tools';
import { Informer } from '@consta/uikit/Informer';
import { Text } from '@consta/uikit/Text';
import classNames from 'classnames';
import { t } from 'i18next';

const RULE_FIELDS = ['requireNumber', 'requireUppercase', 'requireLowercase', 'requireSpecialChars'];

@observer
export class PasswordWithValidate extends React.Component {
	@observable accessor minLength = 6;
	rules = [];
	@observable accessor invalidRules = [];

	constructor(props) {
		super(props);
		this.init();
	}

	init = async () => {
		if (this.props.options) {
			for (const key in this.props.options) {
				if (key === 'minLength') {
					this[key] = parseInt(this.props.options[key]);
				} else if (RULE_FIELDS.includes(key)) {
					const boolVal =
						typeof this.props.options[key] === 'string' ? stringToBoolean(this.props.options[key]) : this.props.options[key];
					if (boolVal === true) {
						this.rules.push(key);
					}
				}
			}
		}
		if (!Object.keys(this.props.options || {}).some((key) => key !== 'minLength')) {
			this.rules.push('requireNumber');
		}
		if (this.props.value) {
			this.invalidRules = checkPassword(this.props.value, this.minLength, this.rules);
		}
	};

	onChange = (value) => {
		this.invalidRules = value ? checkPassword(value, this.minLength, this.rules) : [];
		if (this.props.onChange) {
			this.props.onChange(value);
		}
		if (this.props.onCheckInvalid) {
			this.props.onCheckInvalid(this.invalidRules);
		}
	};

	renderItemHint = (prop) => {
		const invalid = this.invalidRules.includes(prop);
		return (
			<div className={classNames('item-hint-password', { invalid: invalid })}>
				{invalid ? renderFaIcons.xMark : renderFaIcons.checkIcon}
				<Text>{prop !== 'minLength' ? t(`password.validation.${prop}`) : t(`password.validation.${prop}`, { length: this.minLength })}</Text>
			</div>
		);
	};

	render() {
		const { value, onCheckInvalid, options, ...fieldPasswordProps } = this.props;

		return (
			<div className='password-with-validate'>
				<FieldPassword {...fieldPasswordProps} value={value} onChange={this.onChange} />
				{!!value && (
					<Informer className='wrapper-password-hint' view='outline' status={this.invalidRules.length ? 'alert' : 'success'}>
						{this.renderItemHint('minLength')}
						{this.rules.map((prop) => this.renderItemHint(prop))}
					</Informer>
				)}
			</div>
		);
	}
}
